import * as React from "react"

import {
    AutocompleteInput,
    Datagrid,
    Edit,
    List,
    ReferenceField,
    ReferenceInput,
    SelectInput,
    Show,
    SimpleForm,
    SimpleShowLayout,
    TextField,
    TextInput,
    UrlField,
    useEditContext,
    useEditController,
    useShowContext,
} from "react-admin"
import { useEffect, useState } from "react"

import { Container } from "../components/container"
import { ItemDivider } from "../components/divider"
import PartyIcon from "@mui/icons-material/Liquor"
import { PostPagination } from "."
import Typography from "@mui/material/Typography"
import { dataProvider } from "../App"

const partiesFilter = [
    <ReferenceInput
        source="name"
        label="Party"
        reference="parties"
        sort={{ field: "name", order: "ASC" }}
    >
        <SelectInput optionValue="id" optionText="name" />
    </ReferenceInput>,
]

const PartiesList = () => (
    <List filters={partiesFilter} pagination={<PostPagination />} perPage={50}>
        <Datagrid rowClick="edit" bulkActionButtons={false}>
            <TextField source="name" />
            <ReferenceField
                source="party_group_id"
                reference="partygroups"
                perPage={50}
            >
                <TextField source="name" />
            </ReferenceField>
            <UrlField source="website" />
            <UrlField source="facebook" />
            <UrlField source="facebook_id" label="Facebook ID" />
            <UrlField source="google_id" label="Google ID" />
        </Datagrid>
    </List>
)

const PartiesEdit = () => {
    const [google_ids, setGoogleIds] = useState([])
    const [facebook_ids, setFacebookIds] = useState([])
    const { record } = useEditController()

    useEffect(() => {
        dataProvider.lookupSocial({ site: "google" }).then((r) => {
            console.log(r)
            setGoogleIds(r)
        })

        dataProvider.lookupSocial({ site: "facebook" }).then((r) => {
            console.log(r)
            setFacebookIds(r)
        })
    }, [])

    return (
        <Container>
            <Typography variant="h4">
                Edit Party {record && record.name}
            </Typography>
            <Edit title={record && record.name}>
                <SimpleForm sx={{ maxWidth: 500 }}>
                    <TextInput source="id" disabled />
                    <TextInput source="name" fullWidth />
                    <ReferenceInput
                        source="party_group_id"
                        reference="partygroups"
                        sort={{ field: "name", order: "ASC" }}
                        perPage={250}
                    >
                        <SelectInput optionText="name" fullWidth />
                    </ReferenceInput>
                    <ItemDivider />
                    <Typography variant="h6" style={{ marginTop: "2em" }}>
                        Socials
                    </Typography>
                    <TextInput source="website" fullWidth />
                    <TextInput source="facebook" fullWidth />
                    <TextInput source="instagram" fullWidth />
                    <TextInput source="twitter" fullWidth />
                    {facebook_ids && (
                        <AutocompleteInput
                            source="facebook_id"
                            choices={facebook_ids}
                            fullWidth
                            label={"Facebook Ad Id"}
                        />
                    )}
                    <TextInput
                        source="facebook_id"
                        fullWidth
                        label={"Facebook Id"}
                    />
                    {google_ids && (
                        <AutocompleteInput
                            source="google_id"
                            choices={google_ids}
                            fullWidth
                            label={"Google Ad Id"}
                        />
                    )}
                    <TextInput source="google_id" label="Google ID" fullWidth />
                </SimpleForm>
            </Edit>
        </Container>
    )
}

const PartiesShow = () => {
    const { record } = useShowContext()

    return (
        <Container>
            <Typography variant="h4">{record && record.name}</Typography>
            <Show title={record && record.name}>
                <SimpleShowLayout sx={{ maxWidth: 500, width: 500 }}>
                    <TextField source="id" disabled />
                    <TextField source="name" />
                    <ReferenceField
                        label="Party Group"
                        source="party_group_id"
                        reference="partygroups"
                    >
                        <TextField source="name" />
                    </ReferenceField>
                    <UrlField source="website" />
                    <UrlField source="facebook" />
                    <UrlField source="instagram" />
                    <UrlField source="twitter" />
                    <TextField source="facebook_id" label={"Facebook ID"} />
                    <TextField source="google_id" label={"Google Ad ID"} />
                </SimpleShowLayout>
            </Show>
        </Container>
    )
}

const settings = {
    list: PartiesList,
    edit: PartiesEdit,
    show: PartiesShow,
    icon: PartyIcon,
}

export default settings
